import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';
import DTSendMacroAndRefundItemsRBINode from '../NodeGroups/DTCopyTextSendMacro/DTSendMacroAndRefundItemsRBINode/DTSendMacroAndRefundItemsRBINode';

const SendMacroAndRefundItemsRbi = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTSendMacroAndRefundItemsRBINode
      showConfirmation={showConfirmationPage}
      message={'The partial refund has been processed.'}
    />
  );
};

export default SendMacroAndRefundItemsRbi;
